/**
 *
 * Ratings
 *
 */

import IconButton from '@material-ui/core/IconButton';
import PropTypes from 'prop-types';
import React, { useState } from 'react';

import RatingStar from '../images/rating-star';
import useStyles from './styles';

/**
 * @internal
 */
function Ratings({ initialRating /* , name, readOnly */ }) {
  const [tempRating, setTempRating] = useState(initialRating);
  const [rating, setRating] = useState(initialRating);
  const classes = useStyles(); // rating: color -- 1 = RED_400, 2 = ORANGE_400, 3+ = GREEN_400, gray - GRAY_300

  // hover css only?
  const handleMouseEnter = hoveredRating => {
    setTempRating(rating);
    setRating(hoveredRating);
  };

  const handleMouseOut = () => {
    setRating(tempRating);
  };

  const handleClick = idx => {
    setTempRating(idx);
    setRating(idx);
  };

  return (
    <div className={classes.container}>
      {[1, 2, 3, 4, 5].map(idx => (
        <IconButton
          key={idx}
          classes={{ root: classes.iconButton }}
          className={classes.iconButton}
          onClick={() => handleClick(idx)}
          onMouseEnter={() => handleMouseEnter(idx)}
          onMouseLeave={() => handleMouseOut(idx)}
        >
          <RatingStar color={idx <= rating ? 'green400' : undefined} />
        </IconButton>
      ))}
    </div>
  );
}

Ratings.propTypes = {
  initialRating: PropTypes.number,
  // name: PropTypes.string,
  // readOnly: PropTypes.bool,
};

Ratings.defaultProps = {
  initialRating: 0,
  // readOnly: false,
};

/**
 * @internal
 */
export default Ratings;
